import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Lozenge from '@atlaskit/lozenge';
import moment from 'moment';

function lozengeForIncidentStatus (scheduled_for, status) {
  if (scheduled_for !== null) {
    return <Lozenge appearance="inprogress">{status}</Lozenge>;
  }
  return <Lozenge appearance="new">{status}</Lozenge>;
}

const Incident = ({ status, name, updated_at, scheduled_for }) => (
  <div title={name} className={classnames('incident', status)}>
    <div className="name">{name}</div>
    <div className="metadata">
      <span className="lozenge">{lozengeForIncidentStatus(scheduled_for, status)}</span>
      <span className="updated-at">{moment(updated_at).fromNow()}</span>
    </div>
  </div>
);

Incident.propTypes = {
  status: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  updated_at: PropTypes.string.isRequired,
  scheduled_for: PropTypes.string,
};

Incident.defaultProps = {
  scheduled_for: null,
};

export default Incident;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/stride/sidebar/incident.jsx